import { render, staticRenderFns } from "./segments-search.vue?vue&type=template&id=97c5c098"
import script from "./segments-search.vue?vue&type=script&lang=js"
export * from "./segments-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports